import React, { useRef, useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Button } from '@components/base'
import { Carousel } from '@components'
import {
  walkthroughCallsImage,
  walkthroughCoachingImage,
  walkthroughHealthImage,
  walkthroughPlanImage,
} from '@src/assets/images'
import { Storage } from '@src/utils'
import { Analytics, CustomEventTypes } from '@src/config'
import { AppStackParamList } from '@src/navigation/types'
import { CarouselRef } from '@src/components/Carousel/Carousel'

const DATA = [
  {
    title: '1:1 judgement-free coaching built for you',
    description: `Take action with simple changes that lead to steady energy, better digestion, and lasting weight loss.`,
    image: walkthroughCoachingImage.imageSource,
    imageContainerStyle: {
      paddingHorizontal: 24,
    },
    imageStyle: {
      aspectRatio: 0.955,
    },
  },
  {
    title: 'Small changes, big results',
    description: 'Fuel your body, boost energy, and break free from stubborn plateaus.',
    image: walkthroughPlanImage.imageSource,
    imageContainerStyle: {
      paddingHorizontal: 24,
    },
    imageStyle: {
      aspectRatio: 0.955,
    },
  },
  {
    title: 'Structure that works for you',
    description: `Regular check-ins, expert feedback, and tweaks based on your data add accountability without rigidity. So you can keep the progress going.`,
    image: walkthroughCallsImage.imageSource,
    imageContainerStyle: {
      paddingHorizontal: 24,
    },
    imageStyle: {
      aspectRatio: 0.955,
    },
  },
  {
    title: 'Optimize Your Health From the Inside Out',
    description: `See the impact of your effort on your energy, sleep, digestion, and more so you can feel like yourself again.`,
    image: walkthroughHealthImage.imageSource,
    imageContainerStyle: {
      paddingHorizontal: 24,
    },
    imageStyle: {
      aspectRatio: 0.955,
    },
  },
]

const keyExtractor = (item: Pick<typeof DATA[0], 'title'>) => item.title

export const WalkthroughCarousel = () => {
  const styles = useStyleSheet(themedStyle)
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  const carouselRef = useRef<CarouselRef>(null)

  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()

  const onSlideChange = (newSlideIndex: number) => {
    setCurrentSlideIndex(newSlideIndex)
  }

  const isLastSlide = currentSlideIndex === DATA.length - 1

  const buttonText = isLastSlide ? 'Get Started' : 'Next'

  const onButtonPress = () => {
    if (isLastSlide) {
      Storage.set(Storage.WALKTHROUGH_SHOWN_KEY, true)
      Analytics.track(CustomEventTypes.WalkthroughScreenClosed)
      navigation.replace('Auth')
    } else {
      carouselRef.current?.goToSlide(currentSlideIndex + 1)
    }
  }

  return (
    <Carousel
      ref={carouselRef}
      data={DATA}
      keyExtractor={keyExtractor}
      onSlideChange={onSlideChange}
    >
      <Button
        type="primary"
        size="block"
        onPress={onButtonPress}
        accessibilityLabel={buttonText}
        style={styles.button}
      >
        {buttonText}
      </Button>
    </Carousel>
  )
}

const themedStyle = StyleService.create({
  button: {
    marginBottom: 16,
    marginHorizontal: 24,
  },
})
